<template>
  <div>
    <ion-item>
      <ion-label>Search:</ion-label>
      <ion-input v-model="searchText"></ion-input>
    </ion-item>
    <div class="">
      stepping
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import TableGridMobile from './TableGridMobile';

export default {
  name: "MultiInput",
  props: ['title', 'headers', 'rows'],
  components: {
    TableGridMobile
  },
  data() {
    return {
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
      searchText: ''
    }
  },
  methods: {
    styleGridTemplateColumns(frontColumns, numColumns) {
      const style = {gridTemplateColumns: `${frontColumns} repeat(${numColumns}, 2.5rem)`};
      return style;
    }
  },
  computed: {
    indexToFilter() {
      const indexes = [];
      // const indexes = _.findIndex(this.headers, (h) => h.trim() === '' ? true : h.toLowerCase().includes(this.searchText.toLowerCase()), 0);
      // const indexes = _.map();
      for (let i = 0; i < this.headers.length; i++) {
        const isIncluded = this.headers[i].toLowerCase().includes(this.searchText.toLowerCase());
        console.log({
          isIncluded,
          headers: this.headers[i]
        });
        if (isIncluded) indexes.push(i);
      }
      console.log({
        indexes
      });
      return indexes;
    },
    filteredHeaders() {
      // const filtered = _.filter(this.headers, (h) => h.trim() === '' ? true : h.toLowerCase().includes(this.searchText.toLowerCase()));
      const filtered = [];
      for (let i = 0; i < this.indexToFilter.length; i++) {
        filtered.push(this.headers[this.indexToFilter[i]]);
      }
      console.log({
        headers: filtered
      });
      return filtered ? filtered : [];
    },
    filteredRows() {
      console.log({
        rows: this.rows
      });
      const filtered = [];
      for (let r = 0; r < this.rows.length; r++) {
        const row = [];
        for (let i = 0; i < this.indexToFilter.length; i++) {
          row.push(this.rows[r][this.indexToFilter[i]]);
        }
        filtered.push(row);
      }

      console.log({
        rowsFiltered: filtered
      });
      return filtered ? filtered : [];
    }
  }
};
</script>

<style scoped>
.grid-title {
  padding: 1rem;
}
.grid-header {
  display: grid;
  gap: 0.5rem;
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  padding: 0.5rem 1.5rem;
  margin-bottom: 1.5rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
  text-overflow: clip;
  white-space: nowrap;
}

.grid-items {
  display: grid;
  gap: 0.5rem;
  /* grid-template-columns: 4rem 8rem 4rem repeat(auto-fill, 4rem); */
  background: #1d1f22;
  padding: 1rem 1.5rem;
  width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  color: #fff;
  text-overflow: clip;
  white-space: nowrap;
}

.table-grid {
  background: #1d1f22;
  /* padding: 1rem 1.5rem; */
  /* border-radius: 14px; */
  width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  /* line-height: 1rem; */
  /* text-align: center; */
  color: #fff;
  /* grid-template-columns: ; */
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  border-radius: 1rem;
  padding: 0;
  margin: 0;
  background: #1e1f22 !important;
}

</style>
